import React from 'react';
import PageContainer from '../layouts/PageContainer';
import Typography from '@mui/material/Typography';

export default function Coupon() {
  return (
    <PageContainer title="Coupon">
      <Typography variant="body2" color="text.secondary">
        P1 placeholder — path <code>/coupon</code>
      </Typography>
    </PageContainer>
  );
}
